export const messages = {
  en: {
    handover: {
      ownerInfo: 'Owner Information',
      select: 'Select',
      back: 'Back',
      name: 'Name',
      namePlaceholder: 'Required, please enter name',
      gender: 'Gender',
      genderPlaceholder: 'Required, please select gender',
      male: 'Male',
      female: 'Female',
      age: 'Age',
      agePlaceholder: 'Optional, please enter age',
      idCard: 'ID Card',
      idCardPlaceholder: 'Optional, please enter ID card',
      phone: 'Phone',
      phonePlaceholder: 'Required, please enter phone number',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      houseInfo: 'House Information',
      selectHouse: 'Select House',
      createFee: 'Create Fee',
      house: 'House',
      area: 'Area',
      squareMeter: 'Square Meter',
      houseStatus: 'House Status',
      operation: 'Operation',
      delete: 'Delete',
      feeInfo: 'Fee Information',
      feeItem: 'Fee Item',
      startTime: 'Start Time',
      endTime: 'End Time',
      submit: 'Submit',
      submitSuccess: 'Submit successfully',
      submitError: 'Submit failed',
      houseNotUnsold: 'The house is not unsold, please return it first',
      fetchRoomError: 'Failed to get room information'
    },
    selectFeeConfig: {
      title: 'Create Fee',
      feeType: 'Fee Type',
      feeTypePlaceholder: 'Required, please select fee type',
      feeItem: 'Fee Item',
      feeItemPlaceholder: 'Required, please select fee item',
      amount: 'Amount',
      amountPlaceholder: 'Required, please enter amount',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      feeTypeRequired: 'Fee type is required',
      feeItemRequired: 'Fee item is required',
      startTimeRequired: 'Start time is required',
      fetchFeeTypeError: 'Failed to get fee types',
      fetchFeeConfigError: 'Failed to get fee configs'
    }
  },
  zh: {
    handover: {
      ownerInfo: '业主信息',
      select: '选择',
      back: '返回',
      name: '姓名',
      namePlaceholder: '必填，请填写姓名',
      gender: '性别',
      genderPlaceholder: '必填，请选择性别',
      male: '男',
      female: '女',
      age: '年龄',
      agePlaceholder: '可填，请填写年龄',
      idCard: '身份证',
      idCardPlaceholder: '可选，请填写身份证',
      phone: '手机',
      phonePlaceholder: '必填，请填写联系方式',
      remark: '备注',
      remarkPlaceholder: '可填，请填写备注',
      houseInfo: '房屋信息',
      selectHouse: '选择房屋',
      createFee: '创建费用',
      house: '房屋',
      area: '建筑面积',
      squareMeter: '平方米',
      houseStatus: '房屋状态',
      operation: '操作',
      delete: '删除',
      feeInfo: '费用信息',
      feeItem: '费用项目',
      startTime: '开始时间',
      endTime: '结束时间',
      submit: '提交',
      submitSuccess: '提交成功',
      submitError: '提交失败',
      houseNotUnsold: '房屋不是未销售状态，请先退房',
      fetchRoomError: '获取房屋信息失败'
    },
    selectFeeConfig: {
      title: '创建费用',
      feeType: '费用类型',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeItem: '收费项目',
      feeItemPlaceholder: '必填，请选择收费项目',
      amount: '收费金额',
      amountPlaceholder: '必填，请填写收费金额',
      startTime: '计费起始时间',
      startTimePlaceholder: '必填，请填写计费起始时间',
      endTime: '计费结束时间',
      endTimePlaceholder: '必填，请填写计费结束时间',
      feeTypeRequired: '费用类型不能为空',
      feeItemRequired: '收费项目不能为空',
      startTimeRequired: '计费起始时间不能为空',
      fetchFeeTypeError: '获取费用类型失败',
fetchFeeConfigError: '获取收费项目失败'
    }
  },
  'zh-TW': {
    handover: {
      ownerInfo: '業主信息',
      select: '選擇',
      back: '返回',
      name: '姓名',
      namePlaceholder: '必填，請填寫姓名',
      gender: '性別',
      genderPlaceholder: '必填，請選擇性別',
      male: '男',
      female: '女',
      age: '年齡',
      agePlaceholder: '可填，請填寫年齡',
      idCard: '身份證',
      idCardPlaceholder: '可選，請填寫身份證',
      phone: '手機',
      phonePlaceholder: '必填，請填寫聯繫方式',
      remark: '備註',
      remarkPlaceholder: '可填，請填寫備註',
      houseInfo: '房屋信息',
      selectHouse: '選擇房屋',
      createFee: '創建費用',
      house: '房屋',
      area: '建築面積',
      squareMeter: '平方米',
      houseStatus: '房屋狀態',
      operation: '操作',
      delete: '刪除',
      feeInfo: '費用信息',
      feeItem: '費用項目',
      startTime: '開始時間',
      endTime: '結束時間',
      submit: '提交',
      submitSuccess: '提交成功',
      submitError: '提交失敗',
      houseNotUnsold: '房屋不是未銷售狀態，請先退房',
      fetchRoomError: '獲取房屋信息失敗'
    },
    selectFeeConfig: {
      title: '創建費用',
      feeType: '費用類型',
      feeTypePlaceholder: '必填，請選擇費用類型',
      feeItem: '收費項目',
      feeItemPlaceholder: '必填，請選擇收費項目',
      amount: '收費金額',
      amountPlaceholder: '必填，請填寫收費金額',
      startTime: '計費起始時間',
      startTimePlaceholder: '必填，請填寫計費起始時間',
      endTime: '計費結束時間',
      endTimePlaceholder: '必填，請填寫計費結束時間',
      feeTypeRequired: '費用類型不能為空',
      feeItemRequired: '收費項目不能為空',
      startTimeRequired: '計費起始時間不能為空',
      fetchFeeTypeError: '獲取費用類型失敗',
      fetchFeeConfigError: '獲取收費項目失敗'
    }
  }
}